<template>
  <v-card>
    <v-row no-gutters class="px-4 pt-3">
      <v-col cols="0">
        <h4 v-text="$t('text.contacts')" />
      </v-col>
      <!-- 
      <v-col cols="auto">
        <v-checkbox v-model="showInactive" label="Show deactivated" class="ma-0 pa-0" dense hide-details>
        </v-checkbox>
      </v-col>
      -->
    </v-row>
    <!--
          <v-card width="100%" flat class="rounded-0 text-center pt-3 pb-2"
            style="position: absolute; z-index: 5; margin-top: 55px; background:  linear-gradient(0deg, #ffff 80%, transparent 100%);">
            Read more
          </v-card>
          <div class="px-4 py-2" :class="hintExpanded ? 'expanded' : 'collapsed'">
            Bellow is a list of contacts that are connected to this organization.
            Each order in Qwips Service System is required to have a contact person on it.<br>
            The contact person on each order is the person that will receive notifications about the order,
            if they have either sms or email notifications enabled.<br>
            You can create an contact person from an existing account by clicking the "Create contact" button on the
            account menu and visa versa.<br>
            Each contact person can be disabled by clicking the switch on the right side of the list.
            The disabled contacts can be shown by clicking the "Show deactivated" checkbox.
          </div>
           -->
    <v-list class="py-0">
      <ContactListItem :header="true"></ContactListItem>
      <v-progress-linear v-if="loading" absolute indeterminate height="2"></v-progress-linear>
      <ContactListItem v-for="item in filteredContacts" :key="item.Id" :item="item" @toggleActive="toggleActive(item)">
      </ContactListItem>
    </v-list>

    <confirm-dialog ref="ConfirmDialog"></confirm-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      Contact deactivated
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="unToggleActive()">
          {{ $t("text.undo") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>


<script>
import http from "@/api/client";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog.vue";
import ContactListItem from "@/components/ListItems/ContactListItem.vue";
import Vue from "vue";

export default {
  name: "AccountList",
  components: {
    ConfirmDialog,
    ContactListItem,
  },

  data() {
    return {
      hintExpanded: false,

      loading: false,
      contacts: [],
      showInactive: false,

      lastToggledId: null,
      snackbar: false,
      timeout: 5000,
    };
  },

  created() {
    this.getContacts();
  },

  methods: {
    async getContacts() {
      this.loading = true;
      await http()
        .get("api2/customer/userinfo/organization")
        .then((response) => {
          var organization = response.data;
          this.contacts = organization.CustomerPeople;
        });
      this.loading = false;
    },

    async unToggleActive() {
      await this.toggleActiveCall(this.lastToggledId);
      var target = this.contacts.find((x) => x.Id === this.lastToggledId);
      Vue.set(target, "IsActive", !target.IsActive);
      this.snackbar = false;
    },

    async toggleActiveCall(id) {
      var result = await http().patch("api2/customer/userinfo/Contact/ToggleActive/" + id);
      return result;
    },

    async toggleActive(item) {
      var result = true;
      //show confirm dialog if deactivating
      if (!item.IsActive) {
        result = await this.$refs.ConfirmDialog.show({
          title: "Deactivate " + item.Name,
          message: "Are you sure?",
          okButton: "Deactivate",
          cancelButton: "Cancel",
        });
      }
      //undo change if cancel
      if (!result) {
        Vue.set(item, "IsActive", !item.IsActive);
        return;
      }
      else {
        this.lastToggledId = item.Id;
        await this.toggleActiveCall(item.Id);
        this.snackbar = true;
      }
    },
  },

  computed: {
    filteredContacts() {
      return this.contacts.filter((x) => (this.showInactive ? true : x.IsActive));
    },
  },

  watch: {},
};
</script>

<style>
.expanded {}

.collapsed {
  max-height: 90px;
  overflow-y: hidden;
}
</style>